export default "__VITE_ASSET__DECC1K2R__"